const initialState = {};

export default function activityReducer(state = initialState, action) {
  switch (action.type) {
    case "GET_DATA_TABLE_ACTIVITY":
      return {
        ...state,
        dataTable: action.data,
      };
    default:
      return state;
  }
}
